import { render } from "./DebugEnv.vue?vue&type=template&id=5dcd746f"
import script from "./DebugEnv.vue?vue&type=script&lang=js"
export * from "./DebugEnv.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zellwegv/repos-work/ce-365-simple-curve/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__